import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [LIST_BONDS_DEPTS, LIST_BONDS_DEPTS_SUCCESS, LIST_BONDS_DEPTS_FAILURE] =
  createRequestActionTypes('taxbill/LIST_BONDS_DEPTS');

export const listBondsDepts = createAction(
  LIST_BONDS_DEPTS,
  (searchData) => searchData,
);
const listBondsDeptsSaga = createRequestSaga(
  LIST_BONDS_DEPTS,
  taxbillApi.getTaxbills,
);

const SET_BONDS_DEPTS_FILTERS = 'taxbill/SET_BONDS_DEPTS_FILTERS';
export const setBondsDeptsFilters = createAction(
  SET_BONDS_DEPTS_FILTERS,
  (filters) => filters,
);

const RESET_BONDS_DEPTS_FILTERS = 'taxbill/RESET_BONDS_DEPTS_FILTERS';
export const resetBondsDeptsFilters = createAction(RESET_BONDS_DEPTS_FILTERS);

const UNLOAD_BONDS_DEPTS = 'taxbill/UNLOAD_BONDS_DEPTS';
export const unloadBondsDepts = createAction(UNLOAD_BONDS_DEPTS);

export function* bondsDeptsSaga() {
  yield takeLatest(LIST_BONDS_DEPTS, listBondsDeptsSaga);
}

const initialState = {
  bonds_depts: null,
  totalPrice: null,
  defaultFilters: {
    searchInvTyp: '매출', //매입,매출
    searchTyp: '', //월간조회(현재 사용안함)
    searchYn: 'Y', //완료,미완료
    procCompYn: 'N',
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: firstDayofYear,
    searchEndDt: lastDayofYear,
  },
  error: null,
};

const bondsDepts = handleActions(
  {
    [LIST_BONDS_DEPTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totalPrice: data?.totalPrice,
      bonds_depts: data.list.map((inv) => ({
        id: inv.invUuid,
        invUuid: inv.invUuid,
        prjUuid: inv.prjUuid,
        roUuid: inv.roUuid,
        billUuid: inv.billUuid,
        invTyp: inv.invTyp,
        invTxt: inv.invTxt,
        cstNm: inv.cstNm,
        partnerNm: inv.partnerNm,
        invNo: inv.invNo,
        invYn: inv.invYn,
        invAmt: Number(inv.invAmt),
        reqPlanDt: inv.reqPlanDt,
        reqPlanYn: inv.reqPlanYn,
        reqPlanUsr: inv.reqPlanUsr,
        reqPlanUsrNm: inv.reqPlanUsrNm,
        reqPlanTxt: inv.reqPlanTxt,
        salesUsrUuid: inv?.salesUsrUuid,
        salesUsrNm: inv?.salesUsrNm,
        reqCompDt: inv.reqCompDt,
        reqCompYn: inv.reqCompYn,
        reqCompUsr: inv.reqCompUsr,
        reqCompUsrNm: inv.reqCompUsrNm,
        reqCompTxt: inv.reqCompTxt,
        procPlanDt: inv.procPlanDt,
        procPlanYn: inv.procPlanYn,
        procPlanUsrNm: inv.procPlanUsrNm,
        procCompDt: inv.procCompDt,
        procCompYn: inv.procCompYn,
        procTyp: inv.procTyp,
        rsltCompDt: inv.rsltCompDt,
        rsltCompYn: inv.rsltCompYn,
        osTran: inv.osTran,
        crtUsr: inv.crtUsr,
        crtNm: inv.crtNm,
        crtGradeNm: inv.crtGradeNm,
        crtDptNm: inv.crtDptNm,
        crtDt: inv.crtDt,
        cngUsr: inv.cngUsr,
        cngNm: inv.cngNm,
        cngDt: inv.cngDt,
      })),
      error: null,
    }),
    [LIST_BONDS_DEPTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_BONDS_DEPTS]: () => initialState,
    [RESET_BONDS_DEPTS_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_BONDS_DEPTS_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default bondsDepts;
